<template>
  <div class="hello">

    <b-container>

        <b-row>
            <b-col>
                <ul>
                    <li><strong>Transaction Fees:</strong> Keg Seeker uses Stripe for credit card payments. Stripe fees is 2.9% + 30 cents per transaction, which will be deducted from the total charge before forwarding to seller.</li>
                    <li>Payments will be forwarded to the seller typically in 30 businsess days. In some cases, it might take longer.</li>
                    <li>Keg Seeker will hold on to the keg deposit till it's either refunded or forfeited by the buyer.</li>
                    <li>Sellers take responsibility for shipping the items on time.</li>
                    <li>
                        Keg Seeker enables you to sell your Products to third party
                        buyers (“Customers”). You may only sell those Products you have the legal right to sell and must do so
                        consistent with the terms and conditions of this Agreement. All transactions with Customers are
                        between you and the Customer, and you will be the seller of record. Keg Seeker is not a party to any
                        transactions although Keg Seeker will provide the Keg Seeker Services in connection with the
                        transactions. You acknowledge and agree that Keg Seeker may
                        contract with third party service providers to provide Keg Seeker Services, management software and
                        other services.
                    </li>
                    <li>
                        <strong>Abiding by the Law.</strong> You will (and you represent and warrant that you will) comply with
                        all applicable “Laws” (meaning all applicable laws, regulations, legal requirements, and generally
                        accepted industry standards and self-regulatory principles), including Laws related to marketing,
                        packaging, consumer and product safety, product testing, labeling, pricing and packaging, in connection
                        with this Agreement; your use of the Keg Seeker, the Keg Seeker Services, and the
                        Keg Seeker Tools, and your marketing, promotion, offering for sale, or selling any Products through
                        Keg Seeker. Upon Keg Seeker’s request, you will promptly provide Keg Seeker with documentation showing that you have a legal right to sell the Products
                        through Keg Seeker, (iii) documentation (e.g. email verifications from applicable rights
                        holders) showing that you are licensed or otherwise have a right to use any Retailer Product Content (as
                        defined below), and (iv) written certification from an officer of Retailer stating that you have complied
                        with any of your obligations under this Agreement, including, for example and without limitation,
                        compliance with SLAs, consumer product safety laws, and authenticity of Products.
                    </li>
                    <li><strong>Order Process.</strong> All transactions with Customers are between you and the Customer, and
                        you will be the seller of record. Customers will place orders (the “Orders”) using the Keg Seeker
                        checkout system and Keg Seeker will collect all proceeds from such transactions on your behalf. You
                        hereby authorize Keg Seekers LLC as your authorized agent to accept payment from Customers for
                        remittance to you for the Products, and as such when a Customer pays Keg Seekers it shall be
                        construed as if the Customer will be paying you, except for the Keg Seeker fees.
                    </li>
                    <li>
                        Once Keg Seeker transmitted an Order to you, you will, at your
                            own expense, be solely responsible for, and bear all liability for, the fulfillment of the Order, including
                            without limitation, packaging and shipping Products and customer service. If you cannot fulfill the entire
                            quantity of a purchase order (“PO”) line in an Order, then you will cancel that PO line, fulfill all other
                            lines in the Order and promptly notify Keg Seeker of such cancellation. If the Order consists of one
                            PO line that you cannot fulfill the entire quantity for, then you will cancel the entire Order and promptly
                            notify Keg Seeker. If you initiate the cancellation of any Order or PO line in any Order, you will
                            promptly provide Customers with notification of such cancellation in accordance with applicable
                            Law (including, without limitation, the Federal Trade Commission (“FTC”) “Mail or Telephone Order
                            Merchandise Rule”). You will include information requested by Keg Seeker, including the Order
                            number, in the cancellation message sent to Customers. 
                    </li>
                    <li>
                        <strong>Shipping Process.</strong> You will be responsible for shipping all Products purchased by
                        Customers in accordance within the time frame advertised or the processing time specified for such
                        Products through the Keg Seeker (whichever time frame is shorter) or, if no time frame is 
                        advertised or specified, within 30 days (the “On-Time Ship Standard”). You will be responsible for all
                        shipping charges and for any costs or charges related to shipping-related problems, including without
                        limitation, damaged or lost Products, late shipments or misdelivery. If you cannot meet the On-Time
                        Ship Standard for any Product, you will provide the customer with email notification of such delay and
                        include information requested by Keg Seeker in that notification. You will be solely liable for all costs
                        related to any duplicate or inaccurate shipments based upon your retransmission of Order files through
                        any Keg Seeker Tool. You may only send a shipment confirmation notice to customers following
                        shipment of an Order. Packaging for Products should not contain any Retailer marketing materials that
                        are not included as standard marketing materials with all of your Product shipments, and emails sent by
                        you to Customers in connection with an Order will not contain any marketing materials or links to any
                        Retailer or third party website, exc
                    </li>
                    <li>
                        <strong>General Release.</strong> Keg Seekers LLC and its affiliates are not parties to any transactions
                        between you and any Customers or the manufacturers or distributors
                        of the Products. You hereby release (and agree to release) Keg Seekers LLC and its affiliates (and their
                        respective employees, shareholders, directors, agents and representatives) from any all claims, costs,
                        losses, damages (including any indirect, special incidental, or consequential damages), judgments, fines,
                        penalties, penalties, interest, costs, and expenses (including reasonable attorneys' fees and costs of any
                        investigation, defense, and settlement) arising out of any Claims involving you and any third party or
                        governmental entity or agency.
                    </li>
                </ul>
            </b-col>
        </b-row>
    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'

export default {    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser'])
    },

    components: {
    },

    data() {
        return {

        }
    },

    methods:{
        pageChanged(){
            window.scrollTo(0,0)
        },
    },

    mounted(){
    },
}
</script>

